import { Injectable } from '@angular/core';
import { Subject, Observer, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpClientModule } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class CommonServices {
  // host: string = environment.host;
  // ct = new Metadata()
  baseUrl: string = environment.API_SERVER;

  constructor(private _http: HttpClient) {}
  //search country
  getCountries(payload) {
    return this._http.get(this.baseUrl + '/public/countris/');
  }

  getStates(payload) {
    return this._http.get(`${this.baseUrl}/public/state/`);
  }

  messageTemplates(payload) {
    return this._http.get(
      `${this.baseUrl}/public/message_templates/${payload.messageTemplateId}/`
    );
  }

  getLgas(payload) {
    return this._http.get(this.baseUrl + '/public/options/');
  }

  getOption(payload) {
    return this._http.get(this.baseUrl + '/public/options/', {
      params: payload.params,
    });
  }

  getForeignDetailse(payload) {
    return this._http.get(
      `${this.baseUrl}/finance/public/message_templates/FOREIGN_ACCOUNT_DETAILS/`
    );
  }
  getTemplate(payload) {
    return this._http.get(
      this.baseUrl +
        '/public/message_templates/' +
        `${payload.messageTemplateId}/`
    );
  }
  initiateTwoFactor(payload) {
    return this._http.post(this.baseUrl + `/two_factor/generate`, payload.body);
  }
  getRecoveryCode(payload) {
    return this._http.get(
      this.baseUrl + `/two_factor/${payload.otp}/recovery_codes`
    );
  }
  validateTwoFactor(payload) {
    return this._http.get(
      this.baseUrl + `/users/${payload.appUserId}/two_factor_auth/`,
      {
        params: payload.params,
      }
    );
  }
  enableTwoFactor(payload) {
    return this._http.post(this.baseUrl + `/two_factor/enable`, payload.body);
  }
  disableTwoFactor() {
    return this._http.delete(this.baseUrl + `/two_factor/disable`);
  }
}
